import type { PropsWithChildren } from 'react';

export const JoinPageHeader = ({ children }: PropsWithChildren) => {
  return (
    <header
      className="relative flex h-140 flex-col justify-center gap-10 bg-[url('/assets/pngs/policy-info-bg.png')] bg-contain bg-right bg-no-repeat px-20"
    >
      {children}
    </header>
  );
};
